export default __webpack_public_path__ + "static/media/redmicabridge-kiyaku-v1.46f4294f.pdf";